import { Stack, Box } from 'braid-design-system';

import {
  PostType,
  type DraftJobListItemFragment,
} from 'src/graphql/__generated__';

import { CardMobileView } from '../CardMobileView';
import { DraftJobActions } from '../JobActions/DraftJobActions/DraftJobActions';
import { JobStatus } from '../JobStatus/JobStatus';
import { JobTitleAndLocation } from '../JobTitleAndLocation/JobTitleAndLocation';

interface Props {
  draftJobs: DraftJobListItemFragment[];
  loading?: boolean;
}

export const DraftListMobile = ({ draftJobs, loading = false }: Props) => (
  <Stack space="small">
    {draftJobs.map((draft) => {
      const {
        id,
        advertiserJobReference,
        createdDate,
        owner,
        locationsV2: locations,
        title,
      } = draft;
      const location = locations?.[0];
      const createdBy = owner?.fullName;
      return (
        <CardMobileView key={id}>
          <Stack space="large">
            <JobStatus isDraft={true} loading={loading} status={status} />
            <JobTitleAndLocation
              id={id}
              isDraft={true}
              advertiserJobReference={advertiserJobReference}
              createdDate={createdDate}
              createdBy={createdBy}
              title={title}
              location={location}
              loading={loading}
              postType={PostType.DIRECT}
            />
            <Box display="flex" alignItems="flexStart">
              <DraftJobActions draftId={id} loading={loading} />
            </Box>
          </Stack>
        </CardMobileView>
      );
    })}
  </Stack>
);
